import IndexedDBService from './indexedDB.service';

export const dbService = new IndexedDBService({
  name: 'flyDB',
  version: 1,
  stores: [
    {
      name: 'conversations',
      options: { keyPath: 'thread_id' },
      indexes: [
        { name: 'title_idx', keyPath: 'title', options: { unique: false } },
        {
          name: 'createAt_idx',
          keyPath: 'createAt',
          options: { unique: false },
        },
        {
          name: 'updateAt_idx',
          keyPath: 'updateAt',
          options: { unique: false },
        },
        {
          name: 'isArchived_idx',
          keyPath: 'isArchived',
          options: { unique: false },
        },
      ],
    },
  ],
});
